import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  height: inherit;\n  padding: 0 16px;\n  cursor: pointer;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  height: 42px;\n  border-top: 1px solid ", ";\n  text-align: right;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  padding: 8px 16px;\n  font-weight: 600;\n  font-size: ", ";\n  border-top: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  color: ", ";\n  background-color: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0;\n  margin: 0 0 8px;\n  list-style: none;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  ", " {\n    padding: 8px 32px;\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n      cursor: not-allowed;\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      font-weight: 700;\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      background-color: ", ";\n    "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0 16px;\n  box-sizing: border-box;\n  height: ", ";\n  font-size: ", ";\n  border-top: ", ";\n  border-right: ", ";\n  border-bottom: ", ";\n  border-left: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", " {\n    ", "\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 8px 0;\n  margin: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  box-sizing: border-box;\n  outline: 0;\n  max-height: ", ";\n  border: ", ";\n  border-color: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  background-color: ", ";\n  z-index: ", ";\n  transform-origin: top center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  transition: transform 300ms;\n  transform: ", ";\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  display: inline-block;\n\n  ", " {\n    pointer-events: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useCallback, useState, useRef } from 'react';
import styled, { css } from 'styled-components';
import { layout } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { ellipsis } from 'polished';
import { Icon } from '../icon/Icon';
import { Button } from '../button/Button';
import { Input, IconWrap } from '../input/Input';
import { Checkbox, Text } from '../checkbox/Checkbox';
import Popper from '../popper/Popper';
import Downshift from 'downshift';
import posed, { PoseGroup } from 'react-pose';

var itemToString = function itemToString(i) {
  return i ? i.name : '';
};

var toggleItem = function toggleItem(item, arr) {
  return arr.includes(item) ? arr.filter(function (x) {
    return x !== item;
  }) : arr.concat(item);
};

var Wrapper = styled.div(_templateObject(), layout, IconWrap);
var StyledInput = styled(Input)(_templateObject2());
var ArrowIcon = styled(Icon).attrs({
  name: 'ARROW_DOWN'
})(_templateObject3(), function (props) {
  return props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
}, function (props) {
  return props.isOpen ? themeGet('select.arrow.up.color') : themeGet('select.arrow.color');
});
var Animation = posed.div({
  enter: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 150,
      ease: 'circOut'
    }
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0,
      ease: 'backOut'
    },
    delay: 0
  }
});
var MenuWrapper = styled(Animation)(_templateObject4(), themeGet('select.menu.maxHeight'), themeGet('select.menu.border'), themeGet('select.menu.borderColor'), themeGet('select.menu.borderRadius'), themeGet('select.menu.boxShadow'), themeGet('select.menu.backgroundColor'), themeGet('select.menu.zIndex'));
var Menu = styled.ul(_templateObject5());
var Item = styled.li(_templateObject6(), themeGet('select.option.height'), themeGet('select.option.fontSize'), themeGet('select.option.border.top'), themeGet('select.option.border.right'), themeGet('select.option.border.bottom'), themeGet('select.option.border.left'), themeGet('select.option.borderRadius'), themeGet('select.option.boxShadow'), themeGet('select.option.color'), themeGet('select.option.backgroundColor'), function (props) {
  return props.hovered && css(_templateObject7(), themeGet('select.option.hover.color'), themeGet('select.option.hover.backgroundColor'));
}, function (props) {
  return props.selected && css(_templateObject8(), themeGet('select.option.selected.color'), themeGet('select.option.selected.backgroundColor'));
}, function (props) {
  return props.disabled && css(_templateObject9(), themeGet('select.option.disabled.color'), themeGet('select.option.disabled.backgroundColor'));
}, Text, ellipsis());
var GroupMenu = styled.ul(_templateObject10(), Item);
var GroupTitle = styled.div(_templateObject11(), themeGet('select.group.title.fontSize'), themeGet('select.group.title.border.top'), themeGet('select.group.title.border.right'), themeGet('select.group.title.border.bottom'), themeGet('select.group.title.border.left'), themeGet('select.group.title.borderRadius'), themeGet('select.group.title.color'), themeGet('select.group.title.backgroundColor'));
var ActionBar = styled.div(_templateObject12(), themeGet('colors.blacks.9'));
var ClearBtn = styled(Button)(_templateObject13());
var Label = styled.span(_templateObject14(), ellipsis());
export var Select = function Select(_ref) {
  var width = _ref.width,
      size = _ref.size,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      options = _ref.options,
      placeholder = _ref.placeholder,
      onChange = _ref.onChange,
      multiple = _ref.multiple,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      _ref$disabledPopper = _ref.disabledPopper,
      disabledPopper = _ref$disabledPopper === void 0 ? false : _ref$disabledPopper,
      inputValue = _ref.inputValue,
      rest = _objectWithoutProperties(_ref, ["width", "size", "defaultValue", "value", "options", "placeholder", "onChange", "multiple", "className", "disabled", "error", "disablePortal", "disabledPopper", "inputValue"]);

  var ele = useRef(null);

  var _useState = useState(value || (defaultValue !== null ? defaultValue : multiple ? [] : null)),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1];

  var onSelectedChange = useCallback(function (option) {
    var result = multiple ? toggleItem(option, selectedItems) : option;

    if (value === undefined) {
      setSelectedItems(result);
    }

    if (typeof onChange === 'function') {
      onChange(result);
    }
  }, [multiple, value, onChange, selectedItems]);

  if (value !== undefined && value !== selectedItems) {
    setSelectedItems(value);
  }

  var onClear = useCallback(function () {
    if (value === undefined) {
      setSelectedItems([]);
    }

    if (typeof onChange === 'function') {
      onChange([]);
    }
  }, [onChange, value]);
  return (
    /*#__PURE__*/
    React.createElement(Downshift, _extends({
      itemToString: itemToString,
      initialSelectedItem: defaultValue,
      selectedItem: multiple ? null : value,
      inputValue: multiple ? selectedItems.length ? inputValue || "Select ".concat(selectedItems.length, " item") : '' : selectedItems ? inputValue || undefined : undefined,
      onSelect: onSelectedChange,
      stateReducer: useCallback(function (state, changes) {
        if (multiple) {
          switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
              return _objectSpread({}, changes, {
                isOpen: true
              });

            default:
              return changes;
          }
        } else {
          switch (changes.type) {
            case Downshift.stateChangeTypes.keyDownEnter:
            case Downshift.stateChangeTypes.clickItem:
              var controledValue = value !== undefined ? {
                selectedItem: value,
                inputValue: itemToString(value)
              } : {};
              return _objectSpread({}, changes, {}, controledValue);

            default:
              return changes;
          }
        }
      }, [multiple, value])
    }, rest), function (_ref2) {
      var getInputProps = _ref2.getInputProps,
          getMenuProps = _ref2.getMenuProps,
          getItemProps = _ref2.getItemProps,
          getRootProps = _ref2.getRootProps,
          isOpen = _ref2.isOpen,
          selectedItem = _ref2.selectedItem,
          highlightedIndex = _ref2.highlightedIndex,
          toggleMenu = _ref2.toggleMenu;
      var rootProps = getRootProps();
      return (
        /*#__PURE__*/
        React.createElement(Wrapper, _extends({
          width: width
        }, rootProps, {
          ref: function ref(node) {
            ele.current = node;
            rootProps.ref(node);
          }
        }),
        /*#__PURE__*/
        React.createElement(StyledInput, _extends({
          className: className,
          size: size,
          suffix:
          /*#__PURE__*/
          React.createElement(ArrowIcon, {
            isOpen: isOpen
          }),
          disabled: disabled,
          error: error,
          readOnly: true,
          placeholder: placeholder
        }, getInputProps(), {
          onClick: function onClick() {
            toggleMenu();
          }
        })),
        /*#__PURE__*/
        React.createElement(Popper, {
          key: "popper",
          disabledPopper: disabledPopper,
          disablePortal: disablePortal,
          keepMounted: true,
          open: isOpen,
          referRef: ele,
          dynamicWidth: true
        }, function (_ref3) {
          var open = _ref3.open;
          return (
            /*#__PURE__*/
            React.createElement(PoseGroup, null, open &&
            /*#__PURE__*/
            React.createElement(MenuWrapper, {
              key: "menu"
            },
            /*#__PURE__*/
            React.createElement(Menu, getMenuProps(), options.map(function (item, index) {
              return Array.isArray(item.options) ?
              /*#__PURE__*/
              React.createElement(GroupMenu, {
                key: item.name
              },
              /*#__PURE__*/
              React.createElement(GroupTitle, null, item.name), item.options.map(function (option) {
                return (
                  /*#__PURE__*/
                  React.createElement(Item, _extends({
                    key: option.name
                  }, getItemProps({
                    item: option,
                    index: option.value,
                    hovered: highlightedIndex === option.value,
                    selected: selectedItem === option,
                    disabled: option.disabled
                  })),
                  /*#__PURE__*/
                  React.createElement(Label, null, itemToString(option)))
                );
              })) :
              /*#__PURE__*/
              React.createElement(Item, _extends({
                key: item.name
              }, getItemProps({
                item: item,
                index: index,
                hovered: highlightedIndex === index,
                selected: selectedItem === item,
                disabled: item.disabled
              })), multiple ?
              /*#__PURE__*/
              React.createElement(Checkbox, {
                onClick: function onClick(event) {
                  return event.stopPropagation();
                },
                checked: selectedItems.includes(item)
              }, itemToString(item)) :
              /*#__PURE__*/
              React.createElement(Label, null, itemToString(item)));
            })), multiple &&
            /*#__PURE__*/
            React.createElement(ActionBar, null,
            /*#__PURE__*/
            React.createElement(ClearBtn, {
              variant: "link",
              size: "small",
              onClick: onClear
            }, "Clear"))))
          );
        }))
      );
    })
  );
};
Select.defaultProps = {
  width: '100%',
  defaultValue: null
};